export default "__VITE_ASSET__xKItoVEz__"